import { Blocks, FieldDropdown, FieldLabel, type Block } from 'blockly/core';

import { getBeginnerPinOptions } from '../pins/pin-selector.js';
import { BEGINNER_DISPLAY_BLOCK_STYLE } from './display-helpers.js';
import { getTftSpiUi } from './tft-spi-ui.js';

const SPI_BUS_INPUT = 'SPI_BUS';
const SPI_CTRL_INPUT = 'SPI_CTRL';

function pinDropdown(): FieldDropdown {
  return new FieldDropdown(() => getBeginnerPinOptions('digital'));
}

function clearPinInputs(block: Block): void {
  if (block.getInput(SPI_BUS_INPUT)) {
    block.removeInput(SPI_BUS_INPUT);
  }
  if (block.getInput(SPI_CTRL_INPUT)) {
    block.removeInput(SPI_CTRL_INPUT);
  }
}

function appendSpiPinDetails(block: Block): void {
  clearPinInputs(block);
  const ui = getTftSpiUi();

  if (ui.mode === 'skyrover-fixed') {
    block.appendDummyInput(SPI_BUS_INPUT).appendField(new FieldLabel(ui.label));
    return;
  }

  if (ui.mode === 'esp-selectable') {
    block
      .appendDummyInput(SPI_BUS_INPUT)
      .appendField('MOSI')
      .appendField(pinDropdown(), 'MOSI_PIN')
      .appendField('MISO')
      .appendField(pinDropdown(), 'MISO_PIN')
      .appendField('SCK')
      .appendField(pinDropdown(), 'SCK_PIN');
    block
      .appendDummyInput(SPI_CTRL_INPUT)
      .appendField('CS')
      .appendField(pinDropdown(), 'CS_PIN')
      .appendField('DC')
      .appendField(pinDropdown(), 'DC_PIN')
      .appendField('RESET')
      .appendField(pinDropdown(), 'RESET_PIN');
    return;
  }

  // Hardware SPI: show fixed bus pins; CS / DC / RESET are selectable.
  block.appendDummyInput(SPI_BUS_INPUT).appendField(new FieldLabel(ui.busLabel));
  block
    .appendDummyInput(SPI_CTRL_INPUT)
    .appendField('CS')
    .appendField(pinDropdown(), 'CS_PIN')
    .appendField('DC')
    .appendField(pinDropdown(), 'DC_PIN')
    .appendField('RESET')
    .appendField(pinDropdown(), 'RESET_PIN');
}

let registered = false;

/** Configure TFT — board-aware SPI pin labels / selectors. */
export function registerBeginnerTftConfigureBlock(): void {
  if (registered || Blocks['beginner_tft_configure']) {
    registered = true;
    return;
  }

  Blocks['beginner_tft_configure'] = {
    init(this: Block) {
      this.appendDummyInput('HEADER').appendField('configure TFT');
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setStyle(BEGINNER_DISPLAY_BLOCK_STYLE);
      this.setTooltip(
        'Sets up the TFT display. Pin choices depend on your board (fixed on Skyrover).',
      );
      this.setHelpUrl('');
      appendSpiPinDetails(this);
    },
  };

  registered = true;
}
